import Component from './Component';
import { onScroll, onResizeDebounced, enableScroll, disableScroll } from '../services/ScrollResizeHandler';

/**
 * --------------------------------------------------------------------------------------------
 * PRIVATE VARIABLES
 * --------------------------------------------------------------------------------------------
 */

const ANIMATION_TIMING = 350; // 350 MS
const OFFSET = 50;
let prevScroll = 0;
let currentScroll = document.body.getBoundingClientRect().top;
let handleTransition;
let rafTimer;


/**
 * --------------------------------------------------------------------------------------------
 * HELPER FUNCTIONS
 * --------------------------------------------------------------------------------------------
 */







/**
 * --------------------------------------------------------------------------------------------
 * EXPORTS
 * --------------------------------------------------------------------------------------------
 */



export default class Navigation extends Component {

  decorator () {
    return {
      selector : '.js-navigation',
      name : 'Navigation',
    }
  }


  constructor(element) {
    super(element);

    // INITIAL CALLS
    this.cacheElements();
  }

    cacheElements () {
        this.$el = document.querySelector(this.selector);
        this.$toggleMenu = Array.from(this.$el.querySelectorAll('.js-toggle-menu'));
        this.$toggleSearch = Array.from(this.$el.querySelectorAll('.js-toggle-search'));
        this.$menu = this.$el.querySelector('.js-menu');
        this.$overlay = this.$el.querySelector('.js-header-overlay');
        this.$search = this.$el.querySelector('.js-search-overlay');
        this.$searchForm = this.$search.querySelector('.js-search-overlay-form');
        this.$searchInput = this.$searchForm.elements['search_text'];
        this.$suggestions = this.$search.querySelector('.js-search-suggestions');
        this.$menu = this.$el.querySelector('.js-menu');
        this.$menuItems = Array.from(this.$menu.querySelectorAll('.js-menu-item'));

        // On Click Menu
        this.$toggleMenu.forEach((item, idx) => {
            const _this = item;
            item.addEventListener('click', e => {
                e.preventDefault();
                this.toggleNavigation();
            });
        });


        // On click overlay close navigation
        this.$overlay.addEventListener('click', e => {
            e.preventDefault();
            this.closeNavigation();
        });


        // Toggle Sub menu
        this.$menuItems.forEach((item, idx) => {
            this.$menuItem = item;
            this.$menuItemToggle = this.$menuItem.querySelector('.js-menu-toggle');

            if ( !this.$menuItemToggle ) { return; }

            this.$menuItemToggle.addEventListener('click', (e) => {
                e.preventDefault();
                const $parent = e.target.closest('.js-menu-item');
                
                this.toggleMenuItem($parent);
            });
        });


        // Toggle search overlay
        this.$toggleSearch.forEach((item, idx) => {
            const _this = item;

            item.addEventListener('click', e => {
                e.preventDefault();
                this.toggleSearchOverlay();
            });
        });
    }


    // TOGGLE NAVIGATION
    toggleNav () {
        if (!this.$menu.classList.contains('is-active')) {
            this.$menu.classList.add('is-active');
        } else {
            this.$menu.classList.remove('is-active');
        }
    }


    //
    toggleNavigation () {
        if (!this.$overlay.classList.contains('is-active')) {
            disableScroll()
            this.$overlay.classList.add('is-active');
            setTimeout(()=> {
                this.$overlay.classList.add('is-visible');
                this.toggleNav();
            }, 150);
        } else {
            this.closeNavigation();
        }
    }


    // CLOSE NAVIGATION
    closeNavigation () {
        enableScroll();
        this.$menu.classList.remove('is-active');
        this.$overlay.classList.remove('is-visible');
        setTimeout(() => {
            this.$overlay.classList.remove('is-active');
        }, 150);
    }


    // HANDLE ESCAPE KEY
    handleEscape(e) {
        if (e.keyName == 'esc') {
            this.closeNavigation();

            this.$menuItems.forEach((item, idx) => {
                this.closeMenuItem(item);
            })

            this.closeSearchOverlay();
        }
    }


    // TOGGLE SUB MENU
    toggleMenuItem ($parent) {
        if (!$parent.classList.contains('is-active')) {
            $parent.classList.add('is-active');

            setTimeout(() => {
                $parent.classList.add('is-visible');
            }, 250);
        } else {
            this.closeMenuItem($parent);
        }
    }

    // CLOSE SUB MENU
    closeMenuItem ($parent) {
        $parent.classList.remove('is-visible');

        setTimeout(() => {
            $parent.classList.remove('is-active');
        }, 250);
    }


    // Toggle Search
    toggleSearchOverlay () {
        if (!this.$search.classList.contains('is-active')) {
            disableScroll();
            this.$search.classList.add('is-active');
            setTimeout(() => {
                this.$search.classList.add('is-visible');
                // focus on search input field
                // hack: added delay
                setTimeout(() => { this.$searchInput.focus() }, 100);
            }, ANIMATION_TIMING);
        } else {
            this.closeSearchOverlay();
        }
    }


    closeSearchOverlay () {
        enableScroll();
        this.$search.classList.remove('is-visible');
        this.$searchInput.value = '';
        this.$suggestions.innerHTML = '';
        this.$suggestions.classList.remove('is-visible');

        setTimeout(() => {
            this.$search.classList.remove('is-active');
        }, ANIMATION_TIMING);
    }


}
